export function getAll() {
  var items = [
    {
      value: 0,
      name: "SameTime",
      text: "與促銷同時生效",
    },
    {
      value: 1,
      name: "MemberFirst",
      text: "會員優惠優先",
    },
    {
      value: 2,
      name: "PromotionFirst",
      text: "促銷優先",
    },
  ];
  return items;
}
